<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3 class="font-weight-bold">BDM Performance Reports</h3>
            <small class="text-muted">
              Business Development Manager performance and commissions
            </small>
          </div>

          <b-button variant="primary" size="sm">
            <feather-icon icon="DownloadIcon" />
            Export All
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-row>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(59, 130, 246);
                background: linear-gradient(
                  rgb(239, 246, 255),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="text-muted">Active BDMs</span>
              <h3 class="font-weight-bolder">12</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(16, 185, 129);
                background: linear-gradient(
                  rgb(236, 253, 245),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">Total NGR (BDM) </span>
              <h3 class="font-weight-bolder">$342K</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(239, 68, 68);
                background: linear-gradient(
                  rgb(254, 242, 242),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">Commissions Due </span>
              <h3 class="font-weight-bolder">$41K</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(132, 204, 22);
                background: linear-gradient(
                  rgb(247, 254, 231),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">VIP Customers</span>
              <h3 class="font-weight-bolder">856</h3>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-2 bg-white shadow-lg rounded">
      <b-col cols="12" md="2" class="sidebar p-0 bg-white">
        <div class="sidebar-header">Month</div>

        <div
          v-for="month in months"
          :key="month.id"
          class="sidebar-item"
          :class="{ active: monthActive.id === month.id }"
          @click="handleChangeMonth(month)"
        >
          <div class="font-weight-bolder">{{ month.label }}</div>
          <span class="small text-muted">
            {{ monthActive.id === month.id ? "Current" : month.ngr }}
          </span>
        </div>
      </b-col>

      <b-col cols="12" md="2" class="sidebar p-0 border-left bg-white">
        <div class="sidebar-header">BDM List</div>
        <div
          v-for="bdm in bdms"
          :key="bdm.id"
          class="sidebar-item"
          :class="{ active: bdmActive.id === bdm.id }"
          @click="bdmActive = bdm"
        >
          <div class="d-flex" style="gap: 8px">
            <b-avatar size="32" :src="bdm.name" :text="bdm.name" />
            <div>
              <p class="font-weight-bolder mb-0">{{ bdm.label }}</p>
              <span class="small text-muted">{{ bdm.bets }}</span>
            </div>
          </div>
        </div>
      </b-col>

      <b-col cols="12" md="8" class="content-wrapper p-0">
        <!-- HEADER -->
        <div
          class="content-header d-flex justify-content-between align-items-center"
        >
          <span class="font-weight-bolder">
            {{ bdmActive.label }} - {{ monthActive.label }} Reports
          </span>

          <b-badge variant="success">Approved</b-badge>
        </div>

        <div class="p-2">
          <b-row>
            <b-col cols="12">
              <h5 class="font-weight-bolder">Performance Summary</h5>
            </b-col>
            <b-col md="4">
              <div class="stat-card">
                <div class="text-muted small">Customers</div>
                <h5 class="mb-0 font-weight-bold">124</h5>
                <div>
                  <feather-icon
                    icon="ArrowUpIcon"
                    class="text-success"
                    size="12"
                  />
                  <small class="text-success"> +8 vs Dec</small>
                </div>
              </div>
            </b-col>

            <b-col md="4">
              <div class="stat-card">
                <div class="text-muted small">Turnover</div>
                <h5 class="mb-0 font-weight-bold">$892K</h5>
                <div>
                  <feather-icon
                    icon="ArrowUpIcon"
                    class="text-success"
                    size="12"
                  /><small class="text-success"> +12% vs Dec</small>
                </div>
              </div>
            </b-col>

            <b-col md="4">
              <div class="stat-card">
                <div class="text-muted small">NGR</div>
                <h5 class="mb-0 font-weight-bold">$89.2K</h5>
                <div>
                  <feather-icon
                    icon="ArrowUpIcon"
                    class="text-success"
                    size="12"
                  /><small class="text-success"> +15% vs Dec</small>
                </div>
              </div>
            </b-col>
          </b-row>

          <!-- CHART PLACEHOLDER -->
          <div class="chart-box mt-2">
            <h5 class="font-weight-bolder mb-2">Month-to-Month Performance</h5>
              <apexchart
                type="line"
                height="250"
                width="100%"
                :options="ngrChartOptions"
                :series="ngrSeries"
              />
            <div class="d-flex justify-content-between small text-muted">
              <span>NGR Trend (6 months)</span>
              <div>
                <feather-icon
                  icon="ArrowUpIcon"
                  class="text-success"
                  size="12"
                />
                <span class="text-success"> +30.8% growth</span>
              </div>
            </div>
          </div>

          <!-- COMMISSION DETAILS -->
          <div class="mt-4">
            <div class="font-weight-bolder mb-2">Commission Details</div>

            <div class="detail-row">
              <span>Commission Rate</span>
              <strong>12%</strong>
            </div>

            <div class="detail-row">
              <span>Gross Commission</span>
              <strong>$10,704</strong>
            </div>

            <div class="detail-row">
              <span>Adjustments</span>
              <span class="text-danger">-$0</span>
            </div>

            <div class="detail-row total-row">
              <span>Net Commission Due</span>
              <strong class="text-success">$10,704</strong>
            </div>
          </div>

          <!-- FOOTER ACTIONS -->
          <div class="content-footer mt-4">
            <b-button size="sm" variant="outline-secondary" class="mr-1">
              <feather-icon icon="CheckIcon" size="14" />
              Approve
            </b-button>

            <b-button size="sm" variant="outline-primary" class="mr-1">
              <feather-icon icon="DownloadIcon" size="14" />
              Download All
            </b-button>

            <b-dropdown variant="success" size="sm" text="Send to BDM">
              <b-dropdown-item>
                <feather-icon icon="MailIcon" /> Send via Email
              </b-dropdown-item>
              <b-dropdown-item>
                <feather-icon icon="MessageCircleIcon" /> Send SMS
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BFormSelect,
  BButton,
  BDropdown,
  BDropdownItem,
  BAvatar,
  BBadge,
} from "bootstrap-vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BFormSelect,
    BButton,
    BDropdown,
    BDropdownItem,
    BAvatar,
    BBadge,
    FeatherIcon,
    apexchart: VueApexCharts,
  },
  data() {
    const months = [
      { id: 1, label: "January 2026", ngr: "$400K NGR" },
      { id: 2, label: "December 2025", ngr: "$312K NGR" },
      { id: 3, label: "November 2025", ngr: "$298K NGR" },
      { id: 4, label: "October 2025", ngr: "$285K NGR" },
      { id: 5, label: "September 2025", ngr: "$276K NGR" },
      { id: 6, label: "August 2025", ngr: "$268K NGR" },
    ];
    const bdms = [
      { id: 1, label: "Steven Bedwell", bets: "38,456 bets" },
      { id: 2, label: "Michael Hughes", bets: "12,345 bets" },
      { id: 3, label: "Bill Berghouse", bets: "8,234 bets" },
    ];
    const sendOptions = [
      {
        value: "email",
        label: "Send via Email",
        icon: "MailIcon",
      },
      {
        value: "portal",
        label: "Send to BDM Portal",
        icon: "DribbbleIcon",
      },
      {
        value: "sms",
        label: "Send SMS Notification",
        icon: "MessageCircleIcon",
      },
    ];
    return {
      months,
      monthActive: months[0],
      bdmActive: bdms[0],
      bdms,
      sendOptions,
      ngrSeries: [
        {
          name: "NGR",
          data: [52000, 61000, 58000, 72000, 81000, 89200],
        },
      ],

      ngrChartOptions: {
        chart: {
          type: "area",
          height: 260,
          toolbar: { show: false },
          zoom: { enabled: false },
        },

        stroke: {
          curve: "smooth",
          width: 3,
        },

        dataLabels: {
          enabled: false,
        },

        colors: ["#16a34a"],

        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.35,
            opacityTo: 0.05,
            stops: [0, 100],
          },
        },

        grid: {
          borderColor: "#f1f1f1",
          strokeDashArray: 4,
        },

        xaxis: {
          categories: ["Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
          axisBorder: { show: false },
          axisTicks: { show: false },
        },

        yaxis: {
          labels: {
            formatter(val) {
              return "$" + (val / 1000).toFixed(0) + "K";
            },
          },
        },

        tooltip: {
          theme: "light",
          y: {
            formatter(val) {
              return "$" + val.toLocaleString();
            },
          },
        },

        legend: {
          show: false,
        },
      },
    };
  },

  methods: {
    handleChangeMonth(month) {
      this.monthActive = month;
    },
  },
};
</script>

<style scoped>
.sidebar-header {
  padding: 16px;
  font-weight: 700;
  border-bottom: 1px solid #e5e7eb;
}

.sidebar-item {
  padding: 16px;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
  transition: 0.2s;
  border-left: 4px solid transparent;
}

.sidebar-item:hover {
  background: #f9fafb;
}

.sidebar-item.active {
  background: #eef2ff;
  border-left-color: #3b82f6;
}

.content-wrapper {
  background: #fff;
}

.content-header {
  padding: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.content-footer {
  padding: 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  background: #f9fafb;
}
.stat-card {
  background: #f9fafb;
  padding: 16px;
  border-radius: 8px;
}

.chart-box {
  background: #f9fafb;
  padding: 16px;
  border-radius: 8px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f1f1f1;
}

.detail-row:last-child {
  border-bottom: none;
}

.total-row {
  background: #d1fae5;
  padding: 10px;
  border-radius: 4px;
  margin-top: 6px;
}
</style>
